define.alias("ember-math-helpers/helpers/log10", "calendar/helpers/log10");